import {
    Switch,
    useColorModeValue as mode,
    Box,
    Stack,
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useColorModeValue,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    ModalContent,
    ModalCloseButton,
    ModalFooter,
    FormControl,
    FormLabel,
    Input,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import React, { useEffect, memo } from "react";
import { useSession } from "next-auth/client";
import { firebaseClient } from "../../firebaseClient";
import { getAccount } from "../../utils/sessionHelper";
import { useRouter } from "next/dist/client/router";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import toast from "react-hot-toast";
import Thread from "../../components/tweets/masonry/thread";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiShare2 } from 'react-icons/fi';
import { postData, isNumeric } from '../../utils/helpers';
import { PlusIcon } from "components/icons/PlusIcon";

export const ImportTweet = ({ isOpen, onClose, refresher, selectedListId }) => {

    const initialRef = React.useRef<HTMLInputElement>(null);
    const isAuthenticated = useFirebaseUser();
    const [session, loading] = useSession();
    const router = useRouter();
    const [isImporting, setIsImporting] = React.useState(false);
    const [toImportTweets, setToImportTweets] = React.useState("");

    const cancelRef = React.useRef() as React.MutableRefObject<HTMLButtonElement>;

    const handleChange = (event) => setToImportTweets(event.target.value);

    const importTweets = async () => {
        // console.log(toImportTweets);
        let tweets = toImportTweets.split(',');
        let formatedIds = [];
        tweets.forEach(text => {
            // console.log("isNumeric: " + isNumeric(text));
            text = text.split('?')[0];
            if (isNumeric(text))
                //@ts-ignore
                formatedIds.push(text);
            else if (text.includes("twitter.com") || text.includes("x.com")) {
                let split = text.split("/status/");
                if (isNumeric(split[split?.length - 1])) {
                    //@ts-ignore
                    formatedIds.push(split[split?.length - 1]);
                }
            }
            else {
                console.log("Not suported");
                toast.error("Can't read the tweets, check your formating", { style: { background: "gray.600", color: "#222" } });
                onClose();
            }
        })

        // console.log({formatedIds});

        if (formatedIds?.length > 100) {
            toast.error("We don't support more than 100 tweets", { style: { background: "gray.600", color: "#222" } });
            onClose();
        }

        if (isAuthenticated) {
            setIsImporting(true);
            let res = await postData({ url: "user-importTweets", token: "", data: { idUser: getAccount(session)?.id, ids: formatedIds, idList: selectedListId } });

            setIsImporting(false);
            onClose();

            if (res.success) {
                toast.success("Tweets imported successfully", { style: { background: "gray.600", color: "#222" } });
                refresher({});
            }
            else if (res.error) {
                toast.error(res.error);
                refresher({});
            }
            else {
                toast.error("An error occurred during the import. Some tweets has not been imported.", { style: { background: "gray.600", color: "#222" } });
            }
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Import tweets</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl
                        as="form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            importTweets();
                        }}
                    >
                        <FormLabel>Enter tweet ids or urls (comma separated)</FormLabel>
                        <Input placeholder="1387059221901070342,https://twitter.com/heyblake/status/1388483342241251328" onChange={handleChange} />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button variant="tertiary" onClick={onClose}>Cancel</Button>
                    <Button onClick={importTweets} variant={"primary"} isLoading={isImporting}
                        leftIcon={PlusIcon}
                    >
                        Add
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
